import styled from 'styled-components';
import { Column } from '~components';

export const Container = styled(Column)`
  margin-top: ${({ theme }) => theme.spacing.km12};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km8};
  }
`;
